import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const ScrollReveal = ({
  children,
  className = '',
  delay = 0,
  direction = 'up', // up, down, left, right, fade
  duration = 'duration-1000'
}) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.2 });

  const getAnimationClasses = () => {
    const baseClasses = `transition-all ${duration} ease-out`;

    if (!isVisible) {
      switch (direction) {
        case 'up':
          return `${baseClasses} opacity-0 translate-y-8 blur-sm`;
        case 'down':
          return `${baseClasses} opacity-0 -translate-y-8 blur-sm`;
        case 'left':
          return `${baseClasses} opacity-0 translate-x-8 blur-sm`;
        case 'right':
          return `${baseClasses} opacity-0 -translate-x-8 blur-sm`;
        case 'fade':
          return `${baseClasses} opacity-0`;
        case 'scale':
          return `${baseClasses} opacity-0 scale-98`;
        default:
          return `${baseClasses} opacity-0 translate-y-8 blur-sm`;
      }
    }

    return `${baseClasses} opacity-100 translate-y-0 translate-x-0 scale-100 blur-0`;
  };

  return (
    <div
      ref={ref}
      className={`${getAnimationClasses()} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
